import React from "react";
import { InfoIcon } from "lucide-react";

interface CaptionPanelProps {
  caption?: string;
  isFinalCaption: boolean;
}

export function CaptionPanel({ caption, isFinalCaption }: CaptionPanelProps) {
  return (
    <div className="flex flex-col border-r border-slate-100 h-[400px] min-w-0">
      <div className="p-4 flex flex-col gap-2.5 font-sans flex-1 min-h-0">
        <h4 className="text-xs font-bold text-slate-400 uppercase tracking-wider">Caption</h4>
        <div className="p-3 rounded-xl border border-slate-100 bg-slate-50/50 overflow-y-auto flex-1">
          <div className="text-xs leading-relaxed whitespace-pre-wrap">
            {caption ? (
              <div className="text-slate-600">{caption}</div>
            ) : (
              <div className="text-muted-foreground italic">No caption</div>
            )}
          </div>
        </div>
      </div>
      {!isFinalCaption && (
        <div className="flex gap-2 px-4 pb-4 mt-auto">
          <InfoIcon className="size-3 text-slate-400 shrink-0 mt-0.5" />
          <p className="text-xs text-slate-400 leading-normal italic">
            Note: The final caption may be updated with automated hashtags, disclaimers, or mentions based on
            organization settings.
          </p>
        </div>
      )}
    </div>
  );
}
